define([
    "../../hereMapsModule",
    "text!./mapsHerePopUpConfirm.html"
], function (hereMapsModule, mapsHerePopUpConfirm) {
    "use strict";

    return hereMapsModule.service("carrierZoneFreehandDrawingService", [
        "hereMapsService",
        "carrierDrawingCommonService",
        "$translate",
        function (hereMapsService, carrierDrawingCommonService, $translate) {
            var Here = null;
            var map = null;
            var behavior = null;

            var points = []; // H.geo.Point[] — vértices capturados
            var previewPolyline = null; // prévia do polígono
            var onCompleteCallback = null;
            var isDrawing = false; // boleano para marcar quando o desenho occorre
            var isModalOpen = false; // boleano para marcar quando o modal está ativo
            // Eventos
            var pointerDownEvent = null;
            var pointerDragEvent = null;
            var pointerDragendEvent = null;
            // modal
            var confirmModal = null; // modal de confirmação

            return {
                startDrawing: startDrawing,
                cancelDrawing: cancelDrawing
            };

            function cancelDrawing() {
                removeModal();
                cleanup();
                onCompleteCallback = null;
            }

            function startDrawing(callback) {
                onCompleteCallback = callback;

                Here = hereMapsService.getHere();
                map = hereMapsService.getMap();
                behavior = hereMapsService.getBehavior();

                hereMapsService.getBehavior().disable(
                    Here.mapevents.Behavior.Feature.PANNING
                );

                carrierDrawingCommonService.setCursor(true);

                // pointerDown clicou mas não soltou ainda
                // salva o ponto
                pointerDownEvent = function (event) {
                    if (isDrawing || isModalOpen) {
                        return;
                    }
                    if (event.currentPointer.button !== 0) {
                        return;
                    }
                    isDrawing = true;
                    points = [];
                    removeModal();

                    var point = map.screenToGeo(
                        event.currentPointer.viewportX,
                        event.currentPointer.viewportY
                    );
                    points.push(point);
                };

                // arrastou o mouse com o botão pressionado
                pointerDragEvent = function (event) {
                    if (!isDrawing || isModalOpen) {
                        return;
                    }
                    var coordinate = map.screenToGeo(
                        event.currentPointer.viewportX,
                        event.currentPointer.viewportY
                    );
                    var pointA = {
                        x: event.currentPointer.viewportX,
                        y: event.currentPointer.viewportY
                    };
                    var lastPoint = map.geoToScreen(points[points.length - 1]);

                    var distance = carrierDrawingCommonService.getPixelDistance(pointA, lastPoint);

                    if (!carrierDrawingCommonService.isValidDrag(distance)) {
                        return;
                    }

                    points.push(coordinate);
                    updatePreview();

                };

                // após soltar o mouse
                pointerDragendEvent = function (event) {
                    if (isModalOpen) {
                        return;
                    }
                    if (points.length < 3) {
                        cleanup();
                        return;
                    }
                    var screenPos = {
                        x: event.currentPointer.viewportX,
                        y: event.currentPointer.viewportY
                    };
                    createModal(screenPos);
                };
                map.addEventListener("pointerdown", pointerDownEvent);
                map.addEventListener("drag", pointerDragEvent);
                map.addEventListener("dragend", pointerDragendEvent);
            }

            function updatePreview() {
                if (points.length < 2) {
                    return;
                }
                var lineString = new Here.geo.LineString();
                points.forEach(function (p) {
                    lineString.pushPoint(p);
                });

                if (previewPolyline) {
                    previewPolyline.setGeometry(lineString);
                    return;
                }

                previewPolyline = new Here.map.Polyline(lineString, {
                    style: {
                        strokeColor: "#000000",
                        lineWidth: 3,
                        lineCap: "round",
                        lineJoin: "round"
                    },
                    volatility: true
                });
                map.addObject(previewPolyline);
            }

            function createModal(screenPos) {
                confirmModal = document.createElement("div");
                confirmModal.className = "freehand-confirm-modal";
                confirmModal.style.left = (screenPos.x + 12) + "px";
                confirmModal.style.top = (screenPos.y - 40) + "px";
                confirmModal.innerHTML = mapsHerePopUpConfirm;
                confirmModal.querySelector(".btn-confirm")
                    .textContent = $translate.instant("mapsHere.button.confirm");
                confirmModal.querySelector(".btn-cancel")   
                    .textContent = $translate.instant("mapsHere.button.cancel");

                confirmModal.querySelector(".btn-confirm")
                    .addEventListener("click", onConfirm);
                confirmModal.querySelector(".btn-cancel")
                    .addEventListener("click", onCancel);

                map.getViewPort().element.appendChild(confirmModal);
                isModalOpen = true;
                carrierDrawingCommonService.setCursor(false);
            }

            function removeModal() {
                if (confirmModal && confirmModal.parentNode) {
                    confirmModal.parentNode.removeChild(confirmModal);
                }
                confirmModal = null;
                isModalOpen = false;
            }

            function onConfirm() {
                removeModal();

                if (points.length < 3) {
                    cleanup();
                    return;
                }

                var polygon = carrierDrawingCommonService.createClosedPolygon(points);

                onCompleteCallback([polygon]);

                cleanup();
                startDrawing(onCompleteCallback);
            }

            function onCancel() {
                removeModal();
                cleanup();
                startDrawing(onCompleteCallback);
            }

            function cleanup() {
                if (!pointerDownEvent || !pointerDragEvent || !pointerDragendEvent) {
                    return;
                }

                if (previewPolyline) {
                    map.removeObject(previewPolyline);
                    previewPolyline = null;
                }

                if (map) {
                    map.removeEventListener("pointerdown", pointerDownEvent);
                    map.removeEventListener("drag", pointerDragEvent);
                    map.removeEventListener("dragend", pointerDragendEvent);
                }

                if (behavior) {
                    carrierDrawingCommonService.setCursor(false);
                    behavior.enable(
                        Here.mapevents.Behavior.Feature.PANNING
                    );
                }

                points = [];
                isDrawing = false;
                Here = null;
                map = null;
                behavior = null;
            }
        }
    ]);
});